// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper[data-v-0e26d2fa]{\n  display: grid;\n  gap: 1rem; /* 16px */\n}\n.wrapper-tab-item[data-v-0e26d2fa] {\n  display: grid;\n  gap: 1.25rem/* 20px */;\n}\n.wrapper-buttons[data-v-0e26d2fa]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-top: 0.5rem; /* 8px */\n}\n", ""]);
// Exports
module.exports = exports;
